import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
//Helpers
import { hasTilt } from 'src/helpers/interface_helpers';
import { getTargetOptions } from '../core/target_local_options';
//Types
import type { ActionJob, LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';
import type { Device } from 'src/types/Device';

export const getRollerLocalActions = (
	action: ActionJob,
	mainDevice: Device,
	params: { id: number },
): LocalControlOptions[] => {
	const $format = get(format);
	const attr = { target: getTargetOptions(mainDevice) };
	const hasSlat = hasTilt(mainDevice); //not disabled by local web && get(interface_settings)[device.id]?.['cover:0']?.slat?.enable;
	const localControlOptions: LocalControlOptions[] = [
		{
			title: $format('local_action_open_cover', {
				default: 'Open Cover',
			}),
			value: 'cover.open',
			attr,
			params,
		},
		{
			title: $format('local_action_close_cover', {
				default: 'Close Cover',
			}),
			value: 'cover.close',
			attr,
			params,
		},
		{
			title: $format('local_action_stop_cover', {
				default: 'Stop Cover',
			}),
			value: 'cover.stop',
			attr,
			params,
		},
		{
			title: $format('local_action_move_cover', {
				default: 'Move Cover to specific position',
			}),
			value: 'cover.gotoposition',
			attr: {
				pos: typeof action.params?.pos != 'undefined',
				slat_pos: typeof action.params?.slat_pos != 'undefined',
				slat_rel: typeof action.params?.slat_rel != 'undefined',
			},
			params: {
				...params,
				...(typeof action.params?.pos != 'undefined' && {
					pos: action.params.pos,
				}),
				...(typeof action.params?.slat_pos != 'undefined' && {
					slat_pos: action.params.slat_pos,
				}),
				...(typeof action.params?.slat_rel != 'undefined' && {
					slat_rel: action.params.slat_rel,
				}),
			},
		},
	];
	if (!hasSlat) {
		delete localControlOptions[2]?.attr?.slat_pos;
		delete localControlOptions[2]?.attr?.slat_rel;
	}
	return localControlOptions;
};
